/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../routing/state-utils';
import {SIGN_IN_ROUTER_STATE, VIEWS} from './sign-in-views';
import {SignInPageComponent} from './sign-in-page.component';


export function signInStates(_adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
states.add(SIGN_IN_ROUTER_STATE, {
          url: '/' + SIGN_IN_ROUTER_STATE,
          data: {public: true, view: VIEWS.SIGN_IN},
          params: {
            explicitlySignedOut: null,
            dest: null
          },
          component: SignInPageComponent
        }).add('sign-in.masquerade', {
          url: '/masquerade?supportUsername&masqUsername',
          data: {public: true, view: VIEWS.MASQUERADE}
        }).add('sign-in.password-reset', {
          url: '/password-reset',
          data: {public: true, view: VIEWS.RESET_PASSWORD}
        });
  return states.build();
}
